import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      // Cash reconciliations
      opening_date: "Opening date",
      opening_amount: "Opening amount",
      closing_date: "Closing date",
      closing_amount: "Closing amount",
      close_cash: "Close cash",
      select_a_date: "Select a date",
      "cash-reconciliations": "Cash reconciliations",
    },
  },
  es: {
    translation: {
      // General
      close: "Cerrar",
      save_changes: "Guardar cambios",
      create: "Crear",
      actions: "Acciones",
      remove: "Eliminar",
      successfull_action: "Acción realizada con éxito",
      back: "Volver",
      configurations: "Configuraciones",
      users: "Usuarios",
      users_activity: "Actividad de usuario",
      integrations: "Integraciones",
      updates: "Actualizaciones",
      admin: "Administrador",
      worker: "Trabajador",
      finance: "Contable",
      superadmin: "Superadministrador",
      confirmed_account_and_sent_reset_password:
        "Cuenta confirmada. Te enviaremos un correo electrónico para que puedas establecer tu contraseña.",
      password_changing: "Cambio de contraseña",
      change_password: "Cambiar contraseña",
      password_confirmed: "Confirmar contraseña",
      create_user: "Crear usuario",
      role_admin: "Administrador",
      role_worker: "Trabajador",
      role_customer: "Paciente",
      role_finance: "Contable",
      role_superadmin: "Superadministrador",
      user_created_successfully: "Usuario creado con éxito",
      search: "Buscar",

      // Auths
      sign_up: "Identificarse",
      email_or_user: "Correo o usuario",
      email_or_user_placeholder: "Ingrese su correo o usuario",
      password: "Contraseña",
      password_placeholder: "Ingrese su contraseña",
      sign_in: "Iniciar sesión",
      forgot_password: "¿Olvidaste tu contraseña?",
      logout: "Cerrar sesión",

      // Customers
      customers: "Pacientes",
      customer: "Paciente",
      "Create customer": "Crear paciente",
      "are_you_sure_you_want_to_remove_this_customer?":
        "¿Estás seguro de que deseas eliminar este paciente?",
      surnames: "Apellidos",
      phone: "Teléfono",
      mobile: "Móvil",
      nif: "DNI",
      address: "Dirección",
      city: "Ciudad",
      state: "Provincia",
      postal_code: "Código postal",
      observations: "Observaciones",
      customers_and_pets: "Pacientes y mascotas",
      customer_data: "Datos del paciente",
      customer_info: "Paciente",
      customer_status: "Activo",
      first_lastname: "Apellidos",
      profession: "Profesión",
      name: "Nombre",
      email: "Email",
      birthdate: "Fecha de nacimiento",
      origin: "Fuente",
      full_name: "Nombre",
      minor: "Menor de edad",
      tutor_1_name: "Nombre tutor 1",
      tutor_1_nif: "DNI tutor 1",
      tutor_2_name: "Nombre tutor 2",
      tutor_2_nif: "DNI tutor 2",

      // Treatments
      treatments: "Tratamientos",
      treatment: "Tratamiento",
      description: "Descripción",
      duration: "Duración",
      "are_you_sure_you_want_to_remove_this_treatment?":
        "¿Estás seguro de que deseas eliminar este tratamiento?",
      "Create treatment": "Crear tratamiento",
      duration_months: "Duración (meses)",
      treatment_description: "Descripción del tratamiento",

      // Treatment Session Types
      "treatment-session-types": "Tipos de sesiones",
      treatment_session_type: "Tipo de sesión",
      price: "Precio",
      treatment_id: "Tratamiento",
      session_number: "Número de sesiones",
      "are_you_sure_you_want_to_remove_this_treatment_session_type?":
        "¿Estás seguro de que deseas eliminar este tipo de sesión?",
      "Create treatment-session-types": "Crear tipo de sesión",

      // Customers Treatments
      "customers-treatments": "Tratamientos del paciente",
      "Create customer-treatment": "Crear tratamiento de paciente",
      "are_you_sure_you_want_to_remove_this_customers_treatments?":
        "¿Estás seguro de que deseas eliminar este tratamiento de paciente?",
      "Create customer treatment": "Crear tratamiento de paciente",
      "customer treatment": "Tratamiento de paciente",
      treatment_session_type_id: "Tipo de sesión",
      base_price: "Precio base",
      monthly_price: "Precio mensual",
      discount: "Descuento",
      start_date: "Fecha de inicio",
      end_date: "Fecha de fin",
      scholarship: "Beca",
      start_hour: "Hora de inicio",
      days: "Días",
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miércoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sábado",
      sunday: "Domingo",
      therapist_id: "Terapeuta",
      schedule: "Horario",
      "are_you_sure_you_want_to_generate_the_sessions_of_this_customer-treatment?":
        "¿Estás seguro de que deseas generar las sesiones de este tratamiento de paciente a partir del día de hoy. Las sesiones ya agendadas se borrarán?",
      generate_sessions: "Generar sesiones",

      // Therapists
      therapists: "Terapeutas",
      therapist: "Terapeuta",
      "Create therapist": "Crear terapeuta",
      "are_you_sure_you_want_to_remove_this_therapist?":
        "¿Estás seguro de que deseas eliminar este terapeuta?",
      therapist_first_lastname: "Primer apellido",
      second_lastname: "Segundo apellido",
      "Usuario asociado": "Usuario asociado",
      "Color identificativo": "Color identificativo",
      color: "Color",
      "EditSchedule customer-treatment": "Editar horario",

      // Sessions
      sessions: "Sesiones",
      with_treatment: "Con tratamiento",
      customer_id: "Paciente",
      internal_comment: "Comentario interno",
      start_date_time: "Fecha y hora de inicio",
      review: "Valoración",
      status: "Estado",
      video: "Video",
      "Create session": "Crear sesión",
      "are_you_sure_you_want_to_remove_this_session?":
        "¿Estás seguro de que deseas eliminar esta sesión?",
      session_status_0: "Pendiente",
      session_status_1: "Realizada",
      session_status_2: "Cancelada",
      session_status_3: "No ha venido, ha avisado",
      session_status_4: "No ha venido, no ha avisado",
      session_status_5: "Cita recuperada",
      uncoming_sessions: "Próximas sesiones",
      past_sessions: "Sesiones pasadas",
      cancellation_reason: "Motivo de cancelación",
      cancelled_at: "Fecha de cancelación",

      // Deudas
      debts: "Deudas",
      debt: "Deuda",
      "Create debt": "Crear deuda",
      "are_you_sure_you_want_to_remove_this_debt?":
        "¿Estás seguro de que deseas eliminar esta deuda?",
      date: "Fecha",
      amount: "Importe",
      comments: "Comentarios",
      customer_treatment: "Tratamiento",
      customer_treatment_id: "Tratamiento de paciente",
      to_pay: "A pagar",

      // Accounting
      accounting: "Contabilidad",

      // Charges
      charges: "Cobros",
      charge: "Cobro",
      "Create charge": "Crear cobro",
      "are_you_sure_you_want_to_remove_this_charge?":
        "¿Estás seguro de que deseas eliminar este cobro?",
      concept: "Concepto",
      concept_type: "Tipo de concepto",
      debt_id: "Deuda",
      payment_method: "Método de pago",
      attended_by: "Atendido por",

      // Schedules
      schedules: "Horarios",
      "Create schedule": "Crear horario",
      "are_you_sure_you_want_to_remove_this_schedule?":
        "¿Estás seguro de que deseas eliminar este horario?",
      end_hour: "Hora de fin",
      "are_you_sure_you_want_to_generate_the_sessions_of_this_schedule?":
        "¿Estás seguro de que deseas generar las sesiones de este horario a partir del día de hoy. Las sesiones ya agendadas se borrarán?",
      "cancel-schedule": "Cancelar horario",
      cancel_schedule: "Cancelar horario",
      "are_you_sure_you_want_to_cancel_this_schedule?":
        "¿Estás seguro de que deseas cancelar este horario?",
      schedule_status_active: "Activo",
      schedule_status_cancelled: "Cancelado",
      processed: "Procesado",

      // follow-ups
      follow_ups: "Seguimiento",
      follow_up: "Seguimiento",
      clinical_history: "Historia clínica",
      delivered_material: "Material entregado",

      "customer-notes": "Notas del paciente",
      note: "Nota",
      "Create customer-note": "Crear nota del paciente",
      "are_you_sure_you_want_to_remove_this_customer_note?":
        "¿Estás seguro de que deseas eliminar esta nota del paciente?",

      // BI
      reports: "Informes",
      bd_connections: "Conexiones BD",
      billing: "Facturación",
      // Cash reconciliations
      opening_date: "Fecha de apertura",
      opening_amount: "Importe de apertura",
      closing_date: "Fecha de cierre",
      closing_amount: "Importe de cierre",
      close_cash: "Cerrar caja",
      select_a_date: "Selecciona una fecha",
      "cash-reconciliations": "Cierres de caja",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "es", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
